import * as Highcharts from 'highcharts';
import {ChartTemplateService} from '../../../cockpit-shared/charts-templates/chart-template.service'; // NOSONAR
import {SeriesAbsolutPerc} from 'shared/dtos/cockpit/charts/seriesAbsolutPerc'; // NOSONAR
import {
  ABSOLUT,
  ANTEIL,
  GESTAPELT,
  UNGESTAPELT
} from 'shared/EnumsConstants/card-charts-translate-keys.enum'; // NOSONAR
import {Component, Inject, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {GlobalConfig} from 'shared/global-config';

@Component({
  selector: 'app-chart-kompetenzniveau',
  templateUrl: './chart-kompetenzniveau.component.html',
  styleUrl: '../../../cockpit-shared/card/card.component.scss',
  providers: [ChartTemplateService],
  standalone: false
})
export class ChartKompetenzniveauComponent {
  isAllAnf = false;
  chart: any;
  isAbsolut = true;
  stacked = false;
  series: SeriesAbsolutPerc;
  crtSeries: string;
  gestapelt: string = GESTAPELT;
  ungestapelt: string = UNGESTAPELT;
  absolut: string = ABSOLUT;
  anteil: string = ANTEIL;

  constructor(
    @Inject(ChartTemplateService)
    private readonly chartTemplateService: ChartTemplateService,
    private readonly translate: TranslateService
  ) {}

  @Input() set seriesAnzahlMitarbeitend(series: SeriesAbsolutPerc) {
    if (series) {
      this.series = series;
      this.isAllAnf = this.isAllAnfInSeries(series.seriesAbsolute);
      this.initialize(this.series);
    }
  }

  initialize(series: SeriesAbsolutPerc) {
    this.chartTemplateService.chartname = 'kompetenzniveau';
    this.initHighCharts(JSON.parse(series.seriesAbsolute));
    this.toggleDisplayChartSerie(this.chart);
    this.translate.onLangChange.subscribe(() => {
      const svgContainer = document.getElementById(
        'svgContainerChartKompetenzniveau'
      );
      if (svgContainer) {
        this.initHighCharts(JSON.parse(series.seriesAbsolute));
        this.toggleDisplayChartSerie(this.chart);
      }
    });
  }

  selectionAbsolutAnteilChanged(item) {
    if (item.value === ABSOLUT) {
      this.isAbsolut = true;
    } else {
      this.isAbsolut = false;
    }
    this.toggleDisplayChartSerie(this.chart);
  }

  selectionGestapeltUngestepeltChanged(item) {
    if (item.value === GESTAPELT) {
      this.stacked = true;
    } else {
      this.stacked = false;
    }
    this.toggleDisplayChartSerie(this.chart);
  }

  private toggleDisplayChartSerie(chart: any) {
    if (!chart.hasLoaded) {
      this.intitializeChart();
      chart = this.chart;
    }

    if (this.isAbsolut) {
      this.crtSeries = this.series.seriesAbsolute;
    } else {
      this.crtSeries = this.series.seriesPercent;
    }

    if (!chart.series) {
      this.initHighCharts(JSON.parse(this.crtSeries));
    }

    this.setDisplayInfoStackedCharts(chart);
  }

  private setDisplayInfoStackedCharts(chart: Highcharts.Chart) {
    let plotOptions = {};

    const pointFormat = this.isAbsolut
      ? '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y}</span><br/>'
      : '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y} %</span><br/>';

    const valueDecimals = this.isAbsolut ? 0 : 1;
    const tooltip = {
      pointFormat,
      valueDecimals
    };

    const max = this.isAbsolut ? null : 100;
    const labels = this.isAbsolut ? null : '{value}%';
    const ticks = null;

    const title: string = this.isAbsolut
      ? this.translate.instant(
          'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.title'
        )
      : this.translate.instant(
          'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale-anteil.title'
        );

    const footer1Key = 'i18n.cockpit.card.hinveise-grundgesamtheit-gueltig';
    const footer2Key = this.isAllAnf
      ? 'i18n.cockpit.card.hinveise-grundgesamtheit-gueltig.anf8'
      : 'i18n.cockpit.card.hinveise-grundgesamtheit-gueltig.anf4';
    const subtitle = `${this.translate.instant(
      footer1Key
    )} ${this.translate.instant(footer2Key)}`;

    const yAxis = {
      min: 0,
      max,
      title: {text: ''},
      labels: {format: labels},
      tickInterval: ticks
    };

    const series = this.crtSeries
      ? JSON.parse(this.chartTemplateService.translateChart(this.crtSeries))
      : chart.options.series;

    if (this.stacked) {
      plotOptions = {
        plotOptions: {
          series: {stacking: 'normal'}
        },
        title,
        subtitle,
        series,
        tooltip,
        yAxis
      } as Highcharts.PlotOptions;
    } else {
      plotOptions = {
        plotOptions: {
          series: {stacking: ''}
        },
        title,
        subtitle,
        series,
        tooltip,
        yAxis
      };
    }
    chart.update(plotOptions, false);
    chart.setTitle({text: title});
    chart.setSubtitle({
      text: subtitle,
      verticalAlign: 'bottom',
      align: 'left',
      style: {
        fontFamily: 'Arial',
        fontSize: '0.8rem',
        fontStyle: 'italic',
        color: 'gray'
      }
    });
    document.getElementById('svgContainerChartKompetenzniveau').style.width =
      '100%';
    chart.reflow();
    chart.redraw();
  }

  private initHighCharts(series: any) {
    const xAxis = {
      categories: [
        this.translate.instant('i18n.common.frauen'),
        this.translate.instant('i18n.common.maenner')
      ]
    };
    const chartTitle = {
      text: this.translate.instant(
        'i18n.cockpit.card.chart.personenStellenbezogeneMerkmale.title'
      ),
      style: {color: '#333333', fontSize: '16px'}
    };
    const yAxis = {
      labelsFormat: '{value}%',
      min: 0,
      max: 100,
      tickInterval: 10,
      titleText: ''
    };
    const legend = {reversed: true};
    const tooltip = {
      pointFormat:
        '<span style="color:{series.color}">{series.name}</span>: <span style="font-weight:bold;">{point.y}</span><br/>',
      valueDecimals: 0
    };

    this.chartTemplateService.initializeChartValues(
      series,
      chartTitle,
      xAxis,
      yAxis,
      legend,
      this.stacked ? 'normal' : '',
      tooltip
    );

    this.intitializeChart();
  }

  private intitializeChart() {
    Highcharts.chart(
      'svgContainerChartKompetenzniveau',
      this.chartTemplateService.json,
      thechart => {
        this.callBackFuncToNormalizeBarChart(thechart);

        // Observer pour détecter les changements de taille du conteneur
        const resizeObserver = new ResizeObserver(() => {
          if (this.chart) {
            this.chart.reflow();
          }
        });
        resizeObserver.observe(
          document.getElementById('svgContainerChartKompetenzniveau')
        );
      }
    );
  }

  private callBackFuncToNormalizeBarChart(thechart: any) {
    this.chart = thechart;
    thechart.reflow();
  }

  private isAllAnfInSeries(seriesAbsolute) {
    const series = JSON.parse(seriesAbsolute);
    return series.some(item => item.name === GlobalConfig.anfMax.toString());
  }
}
